import React from "react";
import { v4 as uuid } from "uuid";
import PropTypes from "prop-types";

import { IArticle } from "../interfaces/IPackage";
import { getArticleStatus } from "../utils/packageUtils";
import { packages as packageConfig } from '../config/statusConfig'

function tableDetailArticlesPackage({ articles, packageStatus, onDropDownClick }) {
  let content = articles.map((a: IArticle) => {
    const canEdit = [packageConfig.empty, packageConfig.completing].includes(packageStatus)
    return (
      <tr key={uuid()}>
        <td>
          <div className="dropdown">
            <button
              className="btn btn-link"
              type="button"
              id={`dropdown_article_${a.id}`}
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="feather icon-more-vertical-"></i>
            </button>
            <div
              className="dropdown-menu"
              aria-labelledby={`dropdown_article_${a.id}`}
            >
              {canEdit && (
                <>
                  <a
                    className="dropdown-item"
                    href="#!"
                    onClick={onDropDownClick.bind(this, a, "disactive")}
                  >
                    <i className="feather icon-x mr-2"></i>Desactivar
                  </a>
                  <a
                    className="dropdown-item"
                    href="#!"
                    onClick={onDropDownClick.bind(this, a, "active")}
                  >
                    <i className="feather icon-check mr-2"></i>Activar
                  </a>
                  <a
                    className="dropdown-item"
                    href="#!"
                    onClick={onDropDownClick.bind(this, a, "delete")}
                  >
                    <i className="feather icon-delete mr-2"></i>Remover
                  </a>
                  <a
                    className="dropdown-item"
                    href={`/dashboard/articulos/editar/${a.id}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="feather icon-edit mr-2"></i>Editar
                  </a>
                </>
              )}

            </div>
          </div>
        </td>
        <td>{a.id}</td>
        <td>{getArticleStatus(a.status)}</td>
        <td>{a.name}</td>
        <td>{a.track_code}</td>
      </tr>
    )
  });
  return (
    <div className="table-responsive-mobile">
      <table className="table table-borderless">
        <thead>
          <tr>
            <th></th>
            <th>ID</th>
            <th>Estado</th>
            <th>Articulo</th>
            <th>Tracking</th>
          </tr>
        </thead>
        <tbody>{content}</tbody>
      </table>
    </div>
  );
}

tableDetailArticlesPackage.propTypes = {
  articles: PropTypes.array.isRequired,
  onDropDownClick: PropTypes.func.isRequired,
  packageStatus: PropTypes.string.isRequired
};

export default tableDetailArticlesPackage;
